import {createStyles, Theme} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const ProductsManagementStyle = (theme: Theme) =>
  createStyles({
    cardTitle: {
      '& h3': {
        fontSize: '24px !important',
      },
    },
    table: {
      position: 'relative',
      minWidth: 880,
      color: 'red',
      '& td': {
        color: Colors.text.content,
        lineHeight: 2,
        paddingTop: 6,
        paddingBottom: 6,
        height: 43,
      },
    },
    cellRedirect: {
      cursor: 'pointer',
      maxWidth: 400,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    tableHeader: {
      height: 42,
      backgroundColor: Colors.tableHeaderBackground,
      verticalAlign: 'middle',
      borderRadius: 10,
      '& th': {
        color: Colors.text.content,
        lineHeight: '1rem',
        fontWeight: 'bold',
        fontSize: '0.8125rem',
      },
    },
    toolBar: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    searchBar: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 8,
      flexWrap: 'wrap',
      marginBottom: 10,
      '& .MuiOutlinedInput-input': {
        padding: 0,
        margin: 12,
        fontSize: 14,
      },
      [theme.breakpoints.down('md')]: {
        gap: 4,
      },
    },
    searchSelect: {
      width: 130,
      height: 40,
    },
    searchSelectName: {
      width: 160,
      height: 40,
    },
    searchSelectNameV1: {
      width: 220,
      height: 40,
    },
    flexRight: {
      marginLeft: 'auto',
    },
    fieldRadio: {
      minWidth: 160,
      fontSize: 13,
      color: '#5A6268',
      '& > .MuiRadio-colorSecondary.Mui-checked': {
        color: '#10CFC9 !important',
      },
      '@media (max-width: 1920px)': {
        minWidth: 140,
      },
      '@media (max-width: 1800px)': {
        minWidth: 100,
      },
      '@media (max-width: 1700px)': {
        minWidth: 80,
      },
      '@media (max-width: 1400px)': {
        minWidth: 40,
      },
    },
    rowCell: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#F8F8F8',
      },
    },
    checkboxLabel: {
      width: 'fit-content',
    },
  })

export default ProductsManagementStyle
